import { render } from "./toolbelt.vue?vue&type=template&id=19dd2a2a&ts=true"
import script from "./toolbelt.vue?vue&type=script&lang=ts"
export * from "./toolbelt.vue?vue&type=script&lang=ts"

import "./toolbelt.vue?vue&type=style&index=0&id=19dd2a2a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__